import { http } from '@/lib/ats-https';
import * as Sentry from '@sentry/react';

export const axiosAtsQuery =
  () =>
  async ({ url, method = 'get', params = null, data = null }) => {
    try {
      const config = {};
      if (method === 'get') {
        config.url = url;
        config.method = 'get';
        config.params = params;
      } else if (
        method === 'post' ||
        method === 'put' ||
        method === 'delete' ||
        method === 'patch'
      ) {
        config.url = url;
        config.method = method;
        config.params = params;
        config.data = data;
      }
      const result = await http(config);

      if (
        result?.errors?.length > 0 ||
        (result?.errors && Object.keys(result?.errors)?.length > 0)
      ) {
        return {
          error: result?.errors,
        };
      }

      if (url.startsWith('/reports/filters/list')) {
        return {
          data: result,
        };
      }

      // Most ATS endpoints envelope their payload as `{ data, meta }`, so we
      // extract `result.data` below. A few `render json: <raw>` with top-level
      // fields and NO `data`/`meta` — e.g. the bulk-activity add returns
      // `{ id, dispatch_session_id }`. Extracting `.data` there would silently
      // drop the whole payload (and with it `dispatch_session_id`, which the
      // stage-automation underway popup needs), so pass the raw body through.
      if (
        result &&
        typeof result === 'object' &&
        result.data === undefined &&
        result.meta === undefined
      ) {
        return { data: result };
      }

      return {
        data: {
          data: result?.data,
          meta: result?.meta,
        },
      };
    } catch (err) {
      Sentry.captureMessage('http-redux-query-error', (scope) => {
        scope.addBreadcrumb({
          data: {
            error: err,
          },
          level: 'info',
        });
      });
      return {
        // A failed request must always produce a truthy error: a 5xx with an
        // empty body left `data` undefined, so callers saw neither data nor
        // error and reported success.
        error: err?.response?.data || {
          status: err?.response?.status,
          message: err?.message || 'Request failed',
        },
      };
    }
  };
